export const getPaymentMethodDisplayName = (method: string) => {
  switch (method) {
    case "credit_card":
      return "Carte de crédit";
    case "paypal":
      return "PayPal";
    case "apple_pay":
      return "Apple Pay";
    case "google_pay":
      return "Google Pay";
    default:
      return "Autre";
  }
};
